import axios from '@/libs/api.request'

/**
 * 用户行为记录相关 API
 */

// 获取用户行为记录列表
export const getUserBehaviorList = (params) => {
  return axios.request({
    url: '/v1/admin/user_behavior/list',
    method: 'get',
    params
  })
}

// 获取用户行为统计数据
export const getUserBehaviorStatistics = (params) => {
  return axios.request({
    url: '/v1/admin/user_behavior/statistics',
    method: 'get',
    params
  })
}

// 获取用户行为详情
export const getUserBehaviorDetail = (id) => {
  return axios.request({
    url: `/v1/admin/user_behavior/${id}`,
    method: 'get'
  })
}
